'use client';

import { imageService } from '@repo/ui/lib/services/image.service';
import { FileImage } from 'lucide-react';
import { EmptyValue } from './empty-value';

interface ImageValueProps {
  value: string;
  label: string;
  imageType?: 'arbre' | 'epaysage';
}

export function ImageValue({ value, label, imageType = 'arbre' }: ImageValueProps) {
  if (!value || value.trim() === '') {
    return (
      <div className="flex items-center justify-center rounded-lg border border-border/40 bg-muted/20 p-8 dark:border-border/30 dark:bg-muted/10">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted/50 ring-1 ring-border/40 dark:ring-border/30">
            <FileImage className="h-5 w-5 text-muted-foreground/50" aria-hidden="true" />
          </div>
          <span className="text-xs font-medium text-muted-foreground/70 dark:text-muted-foreground/60">
            Aucune image
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-border/60 bg-card ring-1 ring-border/20 shadow-sm dark:border-border/80 dark:ring-border/30">
      <img
        src={imageService.getOptimizedImageUrl(value, imageType, 800, 600)}
        alt={label}
        className="h-auto w-full object-cover"
        loading="lazy"
      />
    </div>
  );
}

